require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-faye-bonnington.json") })
        }
      }, "path---people-faye-bonnington");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-faye-bonnington!./.cache/json/people-faye-bonnington.json
// module id = 1452
// module chunks = 231608221292675